import { valueToPercentage } from 'src/utils/percentage';

export const MINIMAL_SUGGESTED_PRICE_ERROR_MESSAGE =
  'O preço de revenda deve ser maior ou igual ao valor atual do produto.';

const EXPECTED_SELLING_PRICE_PERCENTAGE = 100;

export const validateMinimalSuggestedPrice = (suggestedPrice, fullPrice) => {
  if (!suggestedPrice) {
    return false;
  }

  if (
    valueToPercentage(fullPrice, suggestedPrice) >=
    EXPECTED_SELLING_PRICE_PERCENTAGE
  ) {
    return true;
  }

  return false;
};

export const cleanSuccessfulChanges = (changes, produto) => {
  const newChanges = { ...changes };
  Object.entries(newChanges).forEach(([key, value]) => {
    if (value === produto[key]) {
      delete newChanges[key];
    }
  });
  return newChanges;
};
